<template lang="pug">
.realtime-trans
  .tt {{$t('ui.live_trans')}}
  .ccon
    .rtt-wrap
      .vv-rtt
        template(v-if="topTenList")
          div(v-for="x in topTenList")
            .rttbox
              .rcon
                div
                  span {{ x.member_id }}
                  span.time {{$moment(x.action_date).locale(getLanguageDisplay).fromNow()}}
                div
                  span {{ $tc('ui.topten_'+x.transfer_type) }}
                  span.amo {{ $store.getters.currencyCode }} {{ x.transfer_amount.toFixed(2) }}        
</template>
<script>
import config from "@/config"
export default{
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      topTenList: [],
    }
  },
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getLanguageDisplay(){
      return this.$tc(`ui.language.${this.$store.getters.language}`) || this.$tc('ui.language.en')
    },
  },
  beforeUpdate(){
    $('.vv-rtt').filter('.slick-initialized').slick('unslick');
  },
  updated(){
    $('.vv-rtt').not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      slidesToShow: 6,
      slidesToScroll: 1,
      pauseOnFocus: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
              slidesToShow: 8
          }
        },
        {
          breakpoint: 1600,
          settings: {
              slidesToShow: 8
          }
        },
        {
          breakpoint: 1400,
          settings: {
              slidesToShow: 6
          }
        },
        {
          breakpoint: 1024,
          settings: {
              slidesToShow: 6
          }
        },
        {
          breakpoint: 720,
          settings: {
              slidesToShow: 3
          }
        }
      ]
    });
  },
  mounted(){
    this.getTopTenDepWit()
  },
  methods:{
    getTopTenDepWit(){  //get top ten deposit withdrawal
      let url = config.getTopTenDepositWithdraw();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              if (this.feedback.success == true) {
                this.topTenList = response.data.value
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
          }
        }
      );
      
    },
  }
}
</script>